import { create } from 'zustand';

type Screen = 'screensaver' | 'products' | 'payment' | 'admin';
type ConnectionStatus = 'online' | 'offline' | 'blocked';
type ToastType = 'success' | 'error' | 'warning';

interface ToastMessage {
  text: string;
  type: ToastType;
}

interface BorneState {
  screen: Screen;
  connectionStatus: ConnectionStatus;
  blockReason: string | null;
  retryCount: number;
  toastMessage: ToastMessage | null;
  ticketLimitReached: boolean;

  navigate: (screen: Screen) => void;
  block: (reason: string) => void;
  unblock: () => void;
  setOffline: () => void;
  setOnline: () => void;
  showToast: (text: string, type: ToastType) => void;
  hideToast: () => void;
  setTicketLimitReached: (reached: boolean) => void;
}

export const useBorneStore = create<BorneState>()((set) => ({
  screen: 'screensaver',
  connectionStatus: 'online',
  blockReason: null,
  retryCount: 0,
  toastMessage: null,
  ticketLimitReached: false,

  navigate: (screen) => set({ screen }),

  block: (reason) =>
    set((state) => ({
      connectionStatus: 'blocked',
      blockReason: reason,
      retryCount: state.retryCount + 1,
    })),

  unblock: () =>
    set({
      connectionStatus: 'online',
      blockReason: null,
      retryCount: 0,
    }),

  setOffline: () => set({ connectionStatus: 'offline' }),

  setOnline: () => set({ connectionStatus: 'online' }),

  showToast: (text, type) => set({ toastMessage: { text, type } }),

  hideToast: () => set({ toastMessage: null }),

  setTicketLimitReached: (reached) => set({ ticketLimitReached: reached }),
}));
